import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Navbar = ({ onMenuToggle }) => {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
    setShowMobileMenu(false);
  };

  return (
    <nav style={styles.navbar}>
      <div style={styles.container}>
        <div style={styles.leftSection}>
          {onMenuToggle && (
            <button 
              onClick={onMenuToggle} 
              style={styles.menuToggle}
              aria-label="Toggle menu"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="3" y1="12" x2="21" y2="12"/>
                <line x1="3" y1="6" x2="21" y2="6"/>
                <line x1="3" y1="18" x2="21" y2="18"/>
              </svg>
            </button>
          )}
          <Link to="/dashboard" style={styles.logo}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
              <line x1="9" y1="3" x2="9" y2="21"/>
            </svg>
            <span className="hide-mobile">DashBoard</span>
          </Link>
        </div>

        <div style={styles.menu}>
          {user && (
            <>
              <div style={styles.userInfo} className="hide-mobile">
                <div style={styles.userBadge}>
                  <span style={styles.userName}>{user.fullName}</span>
                  {isAdmin() && (
                    <span style={styles.badge}>Admin</span>
                  )}
                </div>
              </div>
              <button onClick={handleLogout} style={styles.logoutBtn} className="hide-mobile">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                  <polyline points="16 17 21 12 16 7"/>
                  <line x1="21" y1="12" x2="9" y2="12"/>
                </svg>
                Déconnexion
              </button>
              
              {/* Mobile menu button */}
              <button 
                onClick={() => setShowMobileMenu(!showMobileMenu)} 
                style={styles.mobileMenuBtn}
                className="show-mobile"
                aria-label="User menu"
              >
                <div style={styles.userAvatar}>
                  {user.fullName.charAt(0).toUpperCase()}
                </div>
              </button>
            </>
          )}
        </div>
      </div>

      {/* Mobile dropdown menu */}
      {showMobileMenu && (
        <div style={styles.mobileMenu}>
          <div style={styles.mobileMenuHeader}>
            <div style={styles.mobileUserInfo}>
              <div style={styles.mobileUserAvatar}>
                {user.fullName.charAt(0).toUpperCase()}
              </div>
              <div>
                <div style={styles.mobileUserName}>{user.fullName}</div>
                {isAdmin() && (
                  <span style={styles.mobileBadge}>Admin</span>
                )}
              </div>
            </div>
          </div>
          <button onClick={handleLogout} style={styles.mobileLogoutBtn}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
              <polyline points="16 17 21 12 16 7"/>
              <line x1="21" y1="12" x2="9" y2="12"/>
            </svg>
            Déconnexion
          </button>
        </div>
      )}
    </nav>
  );
};

const styles = {
  navbar: {
    background: 'white',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    padding: '1rem 0',
    position: 'sticky',
    top: 0,
    zIndex: 1000,
  },
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 1.5rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  leftSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
  },
  menuToggle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px',
    height: '40px',
    background: 'transparent',
    border: '1px solid var(--border)',
    borderRadius: '0.5rem',
    cursor: 'pointer',
    color: 'var(--text)',
    transition: 'all 0.2s ease',
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    fontSize: '1.25rem',
    fontWeight: 700,
    color: 'var(--primary)',
    textDecoration: 'none',
  },
  menu: {
    display: 'flex',
    alignItems: 'center',
    gap: '1.5rem',
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
  },
  userBadge: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
  },
  userName: {
    fontSize: '0.875rem',
    fontWeight: 500,
    color: 'var(--text)',
  },
  badge: {
    background: 'var(--primary)',
    color: 'white',
    padding: '0.25rem 0.75rem',
    borderRadius: '9999px',
    fontSize: '0.75rem',
    fontWeight: 600,
  },
  logoutBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    padding: '0.5rem 1rem',
    background: 'transparent',
    border: '1px solid var(--border)',
    borderRadius: '0.5rem',
    color: 'var(--text)',
    cursor: 'pointer',
    fontSize: '0.875rem',
    fontWeight: 500,
    transition: 'all 0.2s ease',
  },
  mobileMenuBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: '0.25rem',
  },
  userAvatar: {
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    background: 'var(--primary)',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 600,
    fontSize: '0.875rem',
  },
  mobileMenu: {
    position: 'absolute',
    top: '100%',
    right: '1rem',
    background: 'white',
    borderRadius: '0.75rem',
    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.15)',
    minWidth: '250px',
    padding: '1rem',
    marginTop: '0.5rem',
    animation: 'fadeIn 0.2s ease-out',
  },
  mobileMenuHeader: {
    paddingBottom: '1rem',
    borderBottom: '1px solid var(--border)',
    marginBottom: '1rem',
  },
  mobileUserInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
  },
  mobileUserAvatar: {
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    background: 'var(--primary)',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 600,
    fontSize: '1.125rem',
  },
  mobileUserName: {
    fontSize: '0.875rem',
    fontWeight: 600,
    color: 'var(--text)',
    marginBottom: '0.25rem',
  },
  mobileBadge: {
    background: 'var(--primary)',
    color: 'white',
    padding: '0.125rem 0.5rem',
    borderRadius: '9999px',
    fontSize: '0.75rem',
    fontWeight: 600,
  },
  mobileLogoutBtn: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
    padding: '0.75rem',
    background: 'transparent',
    border: '1px solid var(--border)',
    borderRadius: '0.5rem',
    color: 'var(--text)',
    cursor: 'pointer',
    fontSize: '0.875rem',
    fontWeight: 500,
    transition: 'all 0.2s ease',
  },
};

// Add media queries via style tag
const mediaStyles = `
  @media (max-width: 640px) {
    .hide-mobile {
      display: none !important;
    }
    .show-mobile {
      display: block !important;
    }
  }
  @media (min-width: 641px) {
    .show-mobile {
      display: none !important;
    }
  }
`;

// Inject styles
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement('style');
  styleSheet.textContent = mediaStyles;
  document.head.appendChild(styleSheet);
}

export default Navbar;





